import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

import { UploadDropzoneBorderSize } from '../../types/upload-dropzone-border-size';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Component({
  selector: 'app-upload-dropzone-border',
  imports: [],
  templateUrl: './upload-dropzone-border.component.html',
  styleUrl: './upload-dropzone-border.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDropzoneBorderComponent {
  public readonly size = input<UploadDropzoneBorderSize>('default');

  private readonly cssClasses = new Map<UploadDropzoneBorderSize, string>([
    ['sm', 'border border-gray-200'],
    ['md', 'border-2 border-gray-200'],
    ['lg', 'border-4 border-gray-200'],
    ['xl', 'border-6 border-gray-200'],
    ['default', 'border-4 border-gray-200'],
  ]);

  @HostBinding('class')
  public get sizeCssClass(): string {
    const key = this.size();
    const cssClass = this.cssClasses.get(this.size());

    if (isNil(cssClass)) {
      throw new EntryNotFoundException(
        `The entry for key "${key}" is not found.`,
      );
    }

    return cssClass;
  }
}
